module.exports = __webpack_public_path__ + "static/media/Purple_Exp_Bar@3x.77147074.png";